import React, { useState } from 'react';
import { Form, Input } from '@rocketseat/unform';
import * as Yup from 'yup';
import history from '~/services/history';
import logo from '~/assets/Logo Apolar-pretaeazul01.png';
import { Content } from './styles';
import {
  documentMask,
  documentMaskPhone,
  documentMaskDate,
} from '~/util/documentInputMask';
import apiWSCOM from '~/services/apiWSCOM';

const schema = Yup.object().shape({
  name: Yup.string().required('É obrigatório preencher o nome.'),
  cpf: Yup.string().required('É obrigatório preencher o cpf.'),
  phone: Yup.string().required('É obrigatório preencher o telefone.'),
  email: Yup.string()
    .required('É obrigatório preencher o e-mail.')
    .email('E-mail inválido.'),
  birthday: Yup.string().required(
    'É obrigatório preencher a data de nascimento.'
  ),
});

export default function NewRegister() {
  const [name, setName] = useState('');
  const [cpf, setCPF] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [birthday, setBirthday] = useState('');

  function handleSubmit() {
    apiWSCOM.post('api/email', {
      Destinatario: 'admdigital@ops.digital',
      Subject: 'Novo registro - Área do Cliente',
      EmailBody: `Nome: ${name} <br/> CPF: ${cpf} <br/> Telefone: ${phone} <br/> E-mail: ${email} <br/> Data de nascimento: ${birthday} <br/>`,
    });

    history.push('/RegistroSucesso');
  }

  return (
    <Content>
      <img src={logo} alt="Logo Apolar Imóveis" />
      <Form schema={schema} onSubmit={handleSubmit}>
        <div className="email">E-mail não cadastrado</div>
        <div className="infoEmail">
          Para conseguir acesso preencha os campos abaixo.
        </div>
        <strong className="label">Nome Completo</strong>
        <Input
          maxLength="100"
          name="name"
          placeholder="Digite seu nome completo"
          value={name}
          style={{ width: '100%' }}
          onChange={e => {
            setName(e.target.value);
          }}
        />
        <strong className="label">CPF</strong>
        <Input
          maxLength="14"
          name="cpf"
          placeholder="Digite seu CPF"
          value={cpf}
          style={{ width: '100%' }}
          onChange={e => {
            setCPF(documentMask(e.target.value));
          }}
        />
        <strong className="label">Telefone</strong>
        <Input
          maxLength="15"
          name="phone"
          placeholder="Digite seu telefone"
          value={phone}
          style={{ width: '100%' }}
          onChange={e => {
            setPhone(documentMaskPhone(e.target.value));
          }}
        />
        <strong className="label">E-mail</strong>
        <Input
          maxLength="100"
          name="email"
          placeholder="Digite seu e-mail"
          value={email}
          style={{ width: '100%' }}
          onChange={e => {
            setEmail(e.target.value);
          }}
        />
        <strong className="label">Data de nascimento</strong>
        <Input
          maxLength="10"
          name="birthday"
          placeholder="Digite sua data de nascimento"
          value={birthday}
          style={{ width: '100%' }}
          onChange={e => {
            setBirthday(documentMaskDate(e.target.value));
          }}
        />

        <button type="submit" style={{ marginBottom: 0 }}>
          Próximo
        </button>
      </Form>
    </Content>
  );
}
